module.exports = "/_next/static/images/accenture-logo-93eedec0f5a81e5fa9c8c665c3aa5b22.svg";